export default __webpack_public_path__ + "static/media/Image3.5eb95757.png";